import React from 'react';
import {
  Button,
  Text,
  makeStyles,
  tokens,
} from '@fluentui/react-components';

const useStyles = makeStyles({
  banner: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalM}`,
    backgroundColor: tokens.colorPaletteGreenBackground1,
    borderBottom: `1px solid ${tokens.colorPaletteGreenBorder2}`,
  },
  label: {
    fontSize: tokens.fontSizeBase100,
    color: tokens.colorPaletteGreenForeground1,
  },
});

interface GuidanceBannerProps {
  onDisable: () => Promise<void>;
}

export const GuidanceBanner: React.FC<GuidanceBannerProps> = ({ onDisable }) => {
  const styles = useStyles();

  return (
    <div className={styles.banner}>
      <Text className={styles.label}>Getting started guide</Text>
      <Button appearance="subtle" size="small" onClick={onDisable}>
        Disable guidance
      </Button>
    </div>
  );
};

export default GuidanceBanner;
